// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_mTx","cls2":"Unibrow-cls2_jAe Unibrow-cls1_mTx"};